import React from 'react'
import { css } from '@emotion/css'
import { theme } from '../../styled'

export interface TooltipLabelProps {
  label: string
  renderValue: () => React.ReactNode
  testId?: string
}

const labelContainerCss = css`
  display: flex;
`

const labelCss = css`
  font-weight: ${theme.fontWeights.secondary.boldest};
  margin-right: 2px;
`

const valueCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export function TooltipLabel({
  label,
  renderValue,
  testId
}: TooltipLabelProps) {
  return (
    <div className={labelContainerCss} data-testid={testId}>
      <span className={labelCss}>
        {label}
        {': '}
      </span>
      <span className={valueCss}>{renderValue()}</span>
    </div>
  )
}
